import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import '../../../../App.css';
import { styled } from '../../../../components/styled';
import SpText from '../../../../components/atoms/SpText';
import SpButton from '../../../../components/atoms/SpButton';
import { SpTable, SpTableCell, SpTableRow } from '../../../../components/bundles/SpTable';
import moment from 'moment';
import { Button as MuiButton, FormControlLabel, Grid, Radio, TableCell } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import { createStation, fetchFreeSpotsForciblyClosed, findStationById, updateStation } from '../../../../models/actions/Stations';
import { findRentsByStationId, updateRent } from '../../../../models/actions/Rents';
import { isMobile } from 'react-device-detect';
import { UserSessionContext } from '../../../../App';

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const StationForcedRefunds = (props) => {
  const [currentStation, setCurrentStation] = useState();
  const [currentStationFreeSpots, setCurrentStationFreeSpots] = useState();
  const [stationsList, setStationsList] = useState([]);
  const [rentsList, setRentsList] = useState([]);
  const [displayRentsList, setDisplayRentsList] = useState([]);
  const { stationId } = useParams();
  const history = useHistory();
  const { authData, setAuthData } = useContext(UserSessionContext);

  const { setForcedBikeLockDialog, setSelectedRentDetailOpen, refresh } = props;

  const { register, control, error, getValues, setValue, handleSubmit, reset } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const fetchData = async () => {
    if (stationId) {
      try {
        const responseStation = await findStationById({ id_station: stationId }, authData.accessToken);
        responseStation && setCurrentStation(responseStation);
        const response = await findRentsByStationId({ id_station: stationId }, authData.accessToken);
        if (response) {
          const filteredData = response.filter((elem) => elem.rent.status == 'closed_forcibly');
          setRentsList(filteredData);
          setDisplayRentsList(filteredData);
          let stationsFilteredList = [{ id: -1, client_id: 'Tutte le stazioni' }];
          filteredData.map((elem) => {
            if (stationsFilteredList.filter((elemToSearch) => elemToSearch.id == elem.station.id).length == 0) {
              stationsFilteredList.push(elem.station);
            }
          });
          if (stationsFilteredList) setStationsList(stationsFilteredList);

          //fetch the freespots for the relocking system of forced ended rent's bikes
          const stationFreeSpots = await fetchFreeSpotsForciblyClosed({ station: responseStation }, authData.accessToken);

          setCurrentStationFreeSpots(stationFreeSpots);
          console.log('filter', stationFreeSpots);
        }
      } catch (error) {
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [refresh]);

  const headCells = [
    {
      id: 'bike',
      numeric: false,
      disablePadding: false,
      label: 'Codice bicicletta',
      isAction: false
    },
    {
      id: 'data inizio',
      numeric: false,
      disablePadding: false,
      label: 'Data inizio',
      isAction: false
    },
    {
      id: 'data fine',
      numeric: false,
      disablePadding: false,
      label: 'Data fine',
      isAction: false
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Email utente',
      isAction: false
    },
    {
      id: 'station',
      numeric: false,
      disablePadding: false,
      label: 'Stazione prelievo',
      isAction: false
    },
    {
      id: 'status',
      numeric: false,
      disablePadding: false,
      label: 'Status',
      isAction: false
    },
    {
      id: 'azioni',
      numeric: false,
      disablePadding: false,
      label: '',
      isAction: true
    }
  ];
  //rendering the profile editing form
  const RentRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <SpTableRow
        role="checkbox"
        id={row?.id}
        tabIndex={index}
      >
        <SpTableCell>
          <SpText variant="tableText">{row.bike?.code}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent.start_date && moment(row.rent.start_date).format('DD/MM/yyyy h:m')}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent.end_date && moment(row.rent.end_date).format('DD/MM/yyyy hh:mm')}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.user?.email}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.station?.client_id}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent.status}</SpText>
        </SpTableCell>
        <TableCell
          align={'right'}
          style={{
            padding: 0,
            verticalAlign: 'center',
            borderBottom: 0
          }}
        >
          <SpButton
            text="Riaggancia"
            variant={'tableAction'}
            onClick={() => setForcedBikeLockDialog({ status: true, station: row.station, bike: row.bike, rent: row.rent, free_spots: currentStationFreeSpots })}
          />
        </TableCell>
      </SpTableRow>
    );
  };

  return (
    <div style={{ padding: 8 }}>
      <SpTable
        pagination={true}
        headCells={headCells}
        rows={displayRentsList}
        rowKey="id"
        padding={false}
        notCheckable={false}
        tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
      >
        <RentRow />
      </SpTable>
    </div>
  );
};

export default withSnackbar(StationForcedRefunds);
